import { render } from "./CustomColorPicker.vue?vue&type=template&id=9eb2767e"
import script from "./CustomColorPicker.vue?vue&type=script&lang=js"
export * from "./CustomColorPicker.vue?vue&type=script&lang=js"
script.render = render

export default script